module.exports = __webpack_public_path__ + "img/UF.f15d1a81.png";